import UserLayout from '@/layouts/UserLayout'
import BlankLayout from '@/layouts/BlankLayout'
import BasicLayout from '@/layouts/BasicLayout'
import RouteView from '@/layouts/RouteView'
import PageView from '@/layouts/PageView'

export { UserLayout, BasicLayout, BlankLayout, RouteView, PageView }